import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgHouseOutline = function SvgHouseOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 18.2501V9.90503C21 9.11408 20.6594 8.36143 20.0653 7.83932L13.8153 2.3469C12.7771 1.4345 11.2229 1.4345 10.1847 2.3469L3.93468 7.83932C3.34056 8.36143 3 9.11408 3 9.90503V18.2501C3 19.7689 4.23122 21.0001 5.75 21.0001H8.75C9.7165 21.0001 10.5 20.2166 10.5 19.2501V16.7501C10.5 16.0597 11.0596 15.5001 11.75 15.5001H12.25C12.9404 15.5001 13.5 16.0597 13.5 16.7501V19.2501C13.5 20.2166 14.2835 21.0001 15.25 21.0001H18.25C19.7688 21.0001 21 19.7689 21 18.2501ZM19.5 18.2501V9.90503C19.5 9.54551 19.3452 9.20339 19.0751 8.96607L12.8251 3.47365C12.3532 3.05892 11.6468 3.05892 11.1749 3.47365L4.92486 8.96607C4.6548 9.20339 4.5 9.54551 4.5 9.90503V18.2501C4.5 18.9405 5.05964 19.5001 5.75 19.5001H8.75C8.88807 19.5001 9 19.3882 9 19.2501V16.7501C9 15.2313 10.2312 14.0001 11.75 14.0001H12.25C13.7688 14.0001 15 15.2313 15 16.7501V19.2501C15 19.3882 15.1119 19.5001 15.25 19.5001H18.25C18.9404 19.5001 19.5 18.9405 19.5 18.2501Z"
  })));
};

export { SvgHouseOutline as ReactComponent };
//# sourceMappingURL=house-outline.svg.js.map
